import { cva, type VariantProps } from 'class-variance-authority'

export const dropdownContentVariants = cva('z-dropdown-panel')

export const dropdownItemVariants = cva('z-dropdown-item', {
    variants: {
        variant: {
            default: '',
            destructive: 'z-dropdown-item--destructive',
        },
        inset: {
            true: 'z-dropdown-item--inset',
            false: '',
        },
    },
    defaultVariants: {
        variant: 'default',
        inset: false,
    },
})

export type ZardDropdownItemVariants = VariantProps<typeof dropdownItemVariants>
